enum EquipmentUtilizationLevel {
	TYPE = 'TYPE',
	GROUP = 'GROUP',
	CATEGORY = 'CATEGORY',
	EQUIPMENT_COST = 'EQUIPMENT_COST',
	EQUIPMENT = 'EQUIPMENT'
}

export enum EquipmentUtilizationLevelLabel {
	TYPE = 'Equipment Utilization - Type',
	GROUP = 'Category Group',
	CATEGORY = 'Category',
	EQUIPMENT_COST = 'Subcategory',
	EQUIPMENT = 'Equipment'
}

export const EquipmentUtilizationLevelIndex: { [T in keyof typeof EquipmentUtilizationLevel]: number; } = {
	[EquipmentUtilizationLevel.TYPE]: 0,
	[EquipmentUtilizationLevel.GROUP]: 1,
	[EquipmentUtilizationLevel.CATEGORY]: 2,
	[EquipmentUtilizationLevel.EQUIPMENT_COST]: 3,
	[EquipmentUtilizationLevel.EQUIPMENT]: 4,
} as const;

export const EquipmentUtilizationLevelByIndex: { [index: number]: EquipmentUtilizationLevel; } = {
	[0]: EquipmentUtilizationLevel.TYPE,
	[1]: EquipmentUtilizationLevel.GROUP,
	[2]: EquipmentUtilizationLevel.CATEGORY,
	[3]: EquipmentUtilizationLevel.EQUIPMENT_COST,
	[4]: EquipmentUtilizationLevel.EQUIPMENT,
};

export default EquipmentUtilizationLevel;
